import { useQueryClient } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useDeleteCustomPageTemplateTestIds = pathgen('useDeleteCustomPageTemplateTestIds');
export const useDeleteCustomPageTemplate = function useDeleteCustomPageTemplate() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (param)=>{
            let { businessId, templateId } = param;
            return api.customPageTemplates.delete(businessId, templateId);
        },
        toasts: {
            successMessage: t.proposal.customPages.templates.deleteSuccess(),
            successTestId: useDeleteCustomPageTemplateTestIds.SuccessToast(),
            errorMessage: t.proposal.customPages.templates.deleteError(),
            errorTestId: useDeleteCustomPageTemplateTestIds.ErrorToast()
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.CustomPageTemplates
                ]
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        deleteTemplate: mutate,
        isLoading
    };
};
